/**
 * 根据 pageMeta.i18nPatch 字段解析出运行时展示值：
 * - 无 patch / window.$t 不可用 / key 未命中 / 解析异常 → 原文 fallback
 * - 其它情况 → 走 window.$t(key) 拿翻译
 *
 * patchJson 约定是 JSON.stringify 后的 PatchNode，形如 {"type":"compute","value":"k_xxx"}
 * （见 wuji-helper I18nPatch / PatchNode 类型）。
 *
 * vue-i18n 未命中 key 时会回显 key 本身，这里通过 translated !== key 判断命中状态再回退。
 */
export function resolveI18nField({ raw, patchJson, }) {
    if (!patchJson)
        return raw;
    const $t = typeof window !== 'undefined' ? window.$t : undefined;
    if (typeof $t !== 'function')
        return raw;
    try {
        const patch = JSON.parse(patchJson);
        if (patch?.type !== 'compute' || !patch.value)
            return raw;
        const named$t = window.$t;
        const translated = named$t(patch.value);
        if (typeof translated === 'string' && translated && translated !== patch.value) {
            return translated;
        }
    }
    catch {
        // noop: 兜底回原文
    }
    return raw;
}
